<template>
    <div class="speed-data-section">
        <!-- 模块标题 -->
        <h3>3.4、档位分析</h3>

        <!-- ECharts 柱状图容器 -->
        <div>
            <el-row :gutter="20" style="margin-top: 20px;">
                <!-- 1. 各档位运行百分比饼图 -->
                <el-col :span="24">
                    <el-card shadow="hover">
                        <div class="chart-container" ref="pieChart"></div>
                    </el-card>
                     <div class="table-caption">图表4</div>
                </el-col>

                <!-- 2. 档位运行状态对比条形图 -->
                <el-col :span="24" style="margin-top: 20px;">
                    <el-card shadow="hover">
                        <div class="chart-container" ref="barChart"></div>
                    </el-card>
                           <div class="table-caption">图表5</div>
                </el-col>
            </el-row>
        </div>
       
 

        <!-- 横向多列表格（完全匹配截图） -->
<el-table
      :data="tableData"
      border
      :cell-style="cellStyle"
      :header-cell-style="headerCellStyle"
      style="width: max-content; min-width: 100%;"
    >
      <!-- 转速列（首列） -->
      <el-table-column
        label="转速(r/min)"
        prop="speed"
      
        align="center"
      />
      <!-- 档位列（横向表头） -->
      <el-table-column
        v-for="(gear, idx) in gearHeaders"
        :key="idx"
        :label="gear"
        align="center"
        width="70"
      >
        <template slot-scope="scope">
          {{ scope.row[`gear${gear.replace('档', '')}`] || '0.00' }}
        </template>
      </el-table-column>
      <!-- 累计列 -->
      <el-table-column
        label="累计"
        prop="total"
        width="80"
        align="center"
      />
    </el-table>

        <div class="table-caption">数据表4</div>

        <!-- 说明文本 -->

    </div>
</template>

<script>

export default {
    name: "barchart",

    data() {
        return {
 gearHeaders: ['六档', '五档', '四档', '三档', '二档', '一档'],
      // 表格数据：转速为行，档位为列
      tableData: [
        { speed: '≤700', gear6: '0.66', gear5: '1.19', gear4: '1.36', gear3: '1.38', gear2: '1.85', gear1: '1.07', total: '7.52' },
        { speed: '≤800', gear6: '0.55', gear5: '1.10', gear4: '1.91', gear3: '2.03', gear2: '2.89', gear1: '2.91', total: '11.40' },
        { speed: '≤900', gear6: '0.10', gear5: '0.38', gear4: '0.98', gear3: '1.27', gear2: '1.12', gear1: '0.64', total: '4.49' },
        { speed: '≤1000', gear6: '0.29', gear5: '0.96', gear4: '1.70', gear3: '1.87', gear2: '0.91', gear1: '0.61', total: '6.33' },
        { speed: '≤1100', gear6: '0.45', gear5: '2.11', gear4: '2.75', gear3: '2.22', gear2: '0.82', gear1: '0.05', total: '9.01' },
        { speed: '≤1200', gear6: '1.07', gear5: '3.30', gear4: '3.75', gear3: '1.97', gear2: '0.86', gear1: '0.68', total: '11.63' },
        { speed: '≤1300', gear6: '2.71', gear5: '2.90', gear4: '4.11', gear3: '1.52', gear2: '0.71', gear1: '0.63', total: '12.58' },
        { speed: '≤1400', gear6: '0.90', gear5: '2.07', gear4: '3.49', gear3: '1.43', gear2: '0.67', gear1: '0.46', total: '9.03' },
        { speed: '≤1500', gear6: '5.04', gear5: '2.89', gear4: '2.80', gear3: '1.24', gear2: '0.57', gear1: '0.28', total: '12.82' },
        { speed: '≤1600', gear6: '0.36', gear5: '0.62', gear4: '1.75', gear3: '1.12', gear2: '0.45', gear1: '0.24', total: '10.53' },
        { speed: '≤1700', gear5: '0.85', gear4: '1.18', gear3: '0.66', gear2: '0.33', gear1: '0.20', total: '3.24' },
        { speed: '≤1800', gear4: '0.29', gear3: '0.38', gear2: '0.14', gear1: '0.09', total: '0.90' },
        { speed: '≤1900', gear4: '0.09', gear3: '0.12', gear2: '0.07', gear1: '0.05', total: '0.33' },
        { speed: '≤2000', gear4: '0.09', gear3: '0.04', gear2: '0.02', gear1: '0.01', total: '0.15' },
        { speed: '≤2200', total: '0.00' },
        { speed: '≤2400', total: '0.00' },
        { speed: '>2400', total: '0.00' },
        { speed: '累计', gear6: '12.13', gear5: '24.39', gear4: '26.25', gear3: '17.30', gear2: '11.42', gear1: '8.52', total: '100.00' }
      ]

        };
    },
    mounted() {
        this.initPieChart();
        this.initBarChart();
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
          headerCellStyle({ columnIndex }) {
      if (columnIndex === 0) return { 'background-color': '#f5f7fa' };
      return { 'background-color': '#e6f7ff' };
    },
    // 单元格样式：按数值着色，累计行加粗
    cellStyle({ row, columnIndex }) {
      const speed = row.speed;
      const gearColKey = this.gearHeaders[columnIndex - 1]?.replace('档', '');
      const cellValue = row[`gear${gearColKey}`] || '0.00';
      const value = Number(cellValue);

      // 累计行样式
      if (speed === '累计') {
        return { 'background-color': '#f5f5f5', 'font-weight': 'bold' };
      }
      // 转速列样式
      if (columnIndex === 0) {
        return { 'background-color': '#f5f7fa' };
      }
      // 数值梯度背景色
      if (value >= 5) return { 'background-color': '#fde2e2' }; // 深红
      if (value >= 2) return { 'background-color': '#ffe6e6' }; // 浅红
      if (value >= 1) return { 'background-color': '#e6f7ff' }; // 浅蓝
      if (value > 0) return { 'background-color': '#f0f9eb' }; // 浅绿
      return {};
    },
        // 初始化饼图（各档位运行百分比）
        initPieChart() {
            const pieChart = echarts.init(this.$refs.pieChart);
            const option = {
                title: {
                    text: '各档位运行百分比',
                    left: 'center',
                    textStyle: { fontSize: 16 }
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{b}: {c}%'
                },
                legend: {
                    orient: 'vertical',
                    right: 10,
                    top: 'center',
                    formatter: '{name}: {value}%'
                },
                series: [
                    {
                        type: 'pie',

                        center: ['40%', '50%'],
                        data: [
                            { name: '六档', value: 12.13, itemStyle: { color: '#87CEEB' } },
                            { name: '五档', value: 24.39, itemStyle: { color: '#FFD700' } },
                            { name: '四档', value: 26.25, itemStyle: { color: '#DA70D6' } },
                            { name: '三档', value: 17.30, itemStyle: { color: '#90EE90' } },
                            { name: '二档', value: 11.42, itemStyle: { color: '#4682B4' } },
                            { name: '一档', value: 8.52, itemStyle: { color: '#FFB6C1' } }
                        ],
                        label: {
                            show: true,
                            position: 'outside',
                            formatter: '{b}: {c}%'
                        },
                        labelLine: { show: true }
                    }
                ]
            };
            pieChart.setOption(option);
            this.$pieChart = pieChart;
        },

        // 初始化条形图（档位运行状态对比）
        initBarChart() {
            const barChart = echarts.init(this.$refs.barChart);
            const option = {
                grid: {
                    left: '3%',
                    bottom: '8%',
                    right: '3%',
                    containLabel: true
                },
                title: {
                    text: '档位的运行状态对比',
                    left: 'center',
                    textStyle: { fontSize: 16 }
                },
                tooltip: {
                    trigger: 'axis',
                    formatter: '{b}: {c}%'
                },
                legend: {
                    data: ['经济区', '非经济区'],
                    bottom: 10,
                    left: 'center'
                },
                xAxis: {
                    type: 'value',
                    min: 0,
                    max: 100,
                    axisLabel: { formatter: '{value}%' }
                },
                yAxis: {
                    type: 'category',
                    data: ['一档', '二档', '三档', '四档', '五档', '六档'],
                    inverse: true // 反转Y轴，让“一档”在最下方（与原图一致）
                },
                series: [
                    {
                        name: '经济区',
                        type: 'bar',
                        stack: 'total', // 堆叠模式
                        barWidth: 30,
                        data: [6.29, 11.25, 19.02, 27.14, 24.56, 40.35],
                        itemStyle: { color: '#4682B4' }
                    },
                    {
                        name: '经济区',
                        type: 'bar',
                        stack: 'total',
                        barWidth: 30,
                        data: [6.29, 11.25, 19.02, 27.14, 24.56, 40.35],
                        itemStyle: { color: '#4682B4' }, label: {
                            show: true,
                            position: 'inside',
                            formatter: '{c}%' // 非经济区数值显示在条形右侧
                        }
                    },
                    {
                        name: '非经济区',
                        type: 'bar',
                        stack: 'total',
                        barWidth: 30,
                        data: [93.71, 88.75, 80.19, 72.86, 75.44, 59.65],
                        itemStyle: { color: '#FFD700' },
                        label: {
                            show: true,
                            position: 'inside',
                            formatter: '{c}%' // 非经济区数值显示在条形右侧
                        }
                    }
                ]
            };
            barChart.setOption(option);
            this.$barChart = barChart;
        },

        // 窗口缩放自适应
        handleResize() {
            this.$pieChart?.resize();
            this.$barChart?.resize();
        }

    }
};
</script>
<style scoped>
.chart-container {
    width: 100%;
    height: 400px;
    /* 饼图高度 */
}

/* 条形图容器单独设置高度 */
.el-card:nth-child(2) .chart-container {
    height: 300px;
}
</style>